import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterFlowQuestionOption = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterFlowQuestionOption'),
);
